import React, { useCallback, useState, useRef } from "react";
import { Box, Paper, IconButton } from "@mui/material";
import "./ImageUploader.scss";
import LinkIcon from "../../Assets/Icons/link.svg";

// Match container dimensions from HighlightAndSwap component
const MAX_CONTAINER_WIDTH = 528;
const MIN_CONTAINER_HEIGHT = 528;

export default function ImageUploader({
  inputId = "image-upload",
  label = "Upload from device",
  onUploadFile,
}) {
  const [dragOver, setDragOver] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [inputKey, setInputKey] = useState(Date.now());
  const inputRef = useRef();

  const handleDragOver = useCallback((event) => {
    event.preventDefault();
    setDragOver(true);
  }, []);

  const handleDragLeave = useCallback((event) => {
    event.preventDefault();
    setDragOver(false);
  }, []);

  const handleDrop = useCallback(
    (event) => {
      event.preventDefault();
      setDragOver(false);
      if (event.dataTransfer.files && event.dataTransfer.files[0]) {
        const file = event.dataTransfer.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          setImageSrc(e.target.result);
          onUploadFile?.(file);
          setInputKey(Date.now());
        };
        reader.readAsDataURL(file);
      }
    },
    [onUploadFile]
  );

  const handleChange = useCallback(
    (event) => {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          setImageSrc(e.target.result);
          onUploadFile?.(file);
          setInputKey(Date.now());
        };
        reader.readAsDataURL(file);
      }
    },
    [onUploadFile]
  );

  const handleDelete = () => {
    setImageSrc("");
    onUploadFile?.(null);
  };

  return (
    <div className="simple-image-uploader">
      <input
        key={inputKey}
        ref={inputRef}
        accept="image/*"
        style={{ display: "none" }}
        id={`${inputId}-raised-button-file`}
        multiple={false}
        type="file"
        onChange={handleChange}
      />

      {imageSrc ? (
        <Paper
          variant="outlined"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          className="image-preview"
          style={{
            boxSizing: "border-box",
            border: "none",
            position: "relative",
            padding: 20,
            textAlign: "center",
            cursor: "pointer",
            background: "transparent",
            width: MAX_CONTAINER_WIDTH,
            minWidth: MAX_CONTAINER_WIDTH,
            maxWidth: MAX_CONTAINER_WIDTH,
            height: MIN_CONTAINER_HEIGHT,
            minHeight: MIN_CONTAINER_HEIGHT,
            maxHeight: "none",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={imageSrc}
            alt="Uploaded"
            style={{
              maxWidth: "100%",
              maxHeight: "90%",
              objectFit: "contain",
              position: "absolute",
              left: 0,
              width: "100%",
              top: "12px",
            }}
          />
          <button
            onClick={handleDelete}
            className="delete-button"
            style={{
              position: "absolute",
              bottom: "10px",
              right: "10px",
              background: "#FB4764",
              color: "white",
              border: "none",
              borderRadius: "4px",
              padding: "5px 10px",
              cursor: "pointer",
            }}
          >
            Remove
          </button>
        </Paper>
      ) : (
        <Paper
          variant="outlined"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{
            boxSizing: "border-box",
            border: "none",
            position: "relative",
            padding: 20,
            textAlign: "center",
            cursor: "pointer",
            background: "transparent",
            width: MAX_CONTAINER_WIDTH,
            minWidth: MAX_CONTAINER_WIDTH,
            maxWidth: MAX_CONTAINER_WIDTH,
            height: MIN_CONTAINER_HEIGHT,
            minHeight: MIN_CONTAINER_HEIGHT,
            maxHeight: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <label
            htmlFor={`${inputId}-raised-button-file`}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              placeContent: "center",
              display: "flex",
              top: "0",
              left: "0",
              textAlign: "center",
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              width="100%"
              gap="8px"
            >
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <img alt="" src={LinkIcon} />
              </IconButton>
              <p
                style={{
                  color: "#FB4764",
                  fontSize: "16px",
                  marginTop: "10px",
                  margin: 0,
                }}
              >
                {label}
              </p>
            </Box>
          </label>
        </Paper>
      )}
    </div>
  );
}
